import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import "./Navbar.css";
import staticLogo from "../pages/utils/Logo.jpeg";
import { Link } from "react-router-dom";
import api from "../services/httpService";

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [logoUrl, setLogoUrl] = useState(staticLogo);
  const [logo2Url, setLogo2Url] = useState(null); 
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    fetchLogo();
  }, []);

  const fetchLogo = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data)
          ? res.data.data
          : [res.data.data];
        const latest = allData.sort((a, b) => b.id - a.id)[0];
        if (latest?.websiteLogo) {
          setLogoUrl(latest.websiteLogo);
        }
        if (latest?.websiteLogo2) {
          setLogo2Url(latest.websiteLogo2);
        }
      }
    } catch (err) {
      console.error("Failed to load logo:", err);
    }
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Services", href: "/service" },
    { label: "Contact", href: "/contact" },
    { label: "Gallery", href: "/gallery" },
    { label: "Privacy Policy", href: "/privacy" },
    // {label: "Online Exam", href: "/onlineexam"},
  ];

  return (
    <AppBar position="fixed" className="navbar" elevation={0}>
      <Toolbar>

        {/* ✅ LOGOS — logo1 + logo2 side by side */}
        <Box className="navbar-logos-wrap">
          {/* Logo 1 */}
          <Link to="/">
            <img
              src={logoUrl}
              alt="Logo 1"
              className="navbar-logo"
              onError={() => setLogoUrl(staticLogo)}
            />
          </Link>

          {/* ✅ Logo 2 — uploaded */}
          {logo2Url && (
            <img
              src={logo2Url}
              alt="Logo 2"
              className="navbar-logo navbar-logo2"
              onError={() => setLogo2Url(null)}
            />
          )}
        </Box>

         <Typography
          variant="h6"
          className="navbar-sen"
          style={{ flexGrow: 1 }}
        />

        {/* Desktop Navigation */}
        {!isMobile ? (
          <Box>
            {navLinks.map((link) => (
              <Button
                key={link.label}
                color="inherit"
                href={link.href}
                className="navbar-button"
              >
                {link.label}
              </Button>
            ))}
          </Box>
        ) : (
          <>
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={handleDrawerToggle}
              PaperProps={{
                sx: {
                  width: "70%",
                  padding: "1rem",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px 0 0 8px",
                  animation: "slideIn 0.3s ease-out",
                },
              }}
            >
              <List>
                {navLinks.map((link) => (
                  <ListItem key={link.label} disablePadding>
                    <ListItemButton
                      component="a"
                      href={link.href}
                      onClick={handleDrawerToggle}
                      sx={{
                        padding: "1rem",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "8px",
                        marginBottom: "0.5rem",
                        transition:
                          "transform 0.3s ease, background-color 0.3s ease",
                        "&:hover": {
                          backgroundColor: "#e0e0e0",
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      <ListItemText
                        primary={link.label}
                        primaryTypographyProps={{
                          sx: {
                            fontSize: "1.2rem",
                            fontWeight: "bold",
                            textAlign: "center",
                            color: "#333",
                          },
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Drawer>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
